import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 12px;

  span{
    cursor: auto;
  }

  .col-description{
    padding: 5px;
    padding-left: 15px;
  }

`

export const Title = styled.span`
  font-size: 30px;
  line-height: 30px;
  display: flex;
  color: var(--color-contrast-brand);
  white-space: break-spaces;
`

export const SubTitle = styled.span`
  font-weight: var(--font-weight-semibold);
  font-size: 17px;
  line-height: 14px;
  color: var(--color-action-default);
`

export const DescriptionTitle = styled.span`
  font-weight: var(--font-weight-semibold);
  font-size: 15px;
  line-height: 18px;
  color: var(--color-contrast-brand);
`
export const Description = styled.span`
  font-weight: var(--font-weight-regular);
  font-size: 15px;
  line-height: 18px;
  color: var(--color-contrast-brand);
  white-space: break-spaces;
`
